import React, { useEffect, useState, useMemo, useRef } from 'react';

import fetchAPI from '../../../utils/fetchAPI';
import {
  Box,
  CircularProgress,
  Snackbar,
  Alert,
  AlertTitle,
  Button,
} from '@mui/material';


import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import 'datatables.net-dt/css/dataTables.dataTables.min.css';

DataTable.use(DT);

export const UploadPointsSection = () => {
  const [loading, setLoading] = useState(false);
  const tableRef = useRef(null);

  const [searchValue, setSearchValue] = useState('');

  // Snackbar
  const [snackbar, setSnackbar] = useState({
    open: false,
    title: '',
    message: '',
    severity: 'info', // error | success | info
    confirm: false,
    onConfirm: null,
  });

  const showSnackbar = (title, message, severity = 'info', confirm = false, onConfirm = null) => {
    setSnackbar({
      open: true,
      title,
      message,
      severity,
      confirm,
      onConfirm,
    });
  };

  const tableOptions = useMemo(() => ({
    serverSide: true,
    processing: false,
    ordering: false,
    paging: true,
    searching: true,
    lengthChange: true,
    pageLength: 10,
    searchDelay: 1,
    dom: '<"top"l>rt<"bottom"ip>',
    language: {
      url: '//cdn.datatables.net/plug-ins/1.13.8/i18n/es-ES.json',
    },

    ajax: (dtParams, callback) => {
      const page = dtParams.start / dtParams.length + 1;
      const limit = dtParams.length;
      const search = dtParams.search.value;
      setLoading(true);

      fetchAPI({
        service: `v1/MX/admin/upload/?page=${page}&limit=${limit}&search=${search}`,
        protocol: 'GET',
        callbackThen: (res) => {
          callback({
            draw: dtParams.draw,
            data: res.data,
            recordsTotal: res.pagination.totalItems,
            recordsFiltered: res.pagination.totalFiltered,
          });
          setLoading(false);
        },
        callbackCatch: () => {
          callback({
            draw: dtParams.draw,
            data: [],
            recordsTotal: 0,
            recordsFiltered: 0,
          });
          setLoading(false);
        },
      });
    },

    columns: [
      {
        data: 'customer_no',
        title: 'Customer',
        className: 'dt-left',
      },
      {
        data: 'exclusive',
        title: 'Exclusivo',
        className: 'dt-center',
      },
      {
        data: 'mixed',
        title: 'Mixto',
        className: 'dt-center',
      },
      {
        data: 'created_at',
        title: 'Fecha de creación',
        className: 'dt-center',
        render: (data) => (data ? new Date(data).toLocaleDateString('es-ES') : ''),
      },
      {
        data: 'updated_at',
        title: 'Fecha de actualización',
        className: 'dt-center',
        render: (data) => (data ? new Date(data).toLocaleDateString('es-ES') : ''),
      },
    ],
  }), []);

  return (
    <>
      <h2>Historial de Puntos</h2>
      {/* TABLA */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
          minHeight: '50vh',
          px: 5,
          pb: 5,
        }}
      >
        <Box sx={{ width: '100%' }}>
          {/* Buscador alineado con la tabla */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              mb: 2,
              gap: 1,
            }}
          >
            <span style={{ fontWeight: 500 }}>Buscar cliente:</span>
            <input
              type="text"
              value={searchValue}
              onChange={(e) => {
                const value = e.target.value;

                if (value === '') {
                  setSearchValue('');
                  tableRef.current?.dt()?.search('').draw();
                  return;
                }

                if (!/^\d+$/.test(value)) {
                  showSnackbar('Búsqueda inválida', 'Solo se permiten números.', 'error');
                  return;
                }

                setSearchValue(value);
                tableRef.current?.dt()?.search(value).draw();
              }}
              style={{
                padding: '6px 8px',
                height: '28px',
                borderRadius: '3px',
                border: '1px solid #aaa',
                fontSize: '14px',
                width: '180px',
              }}
            />
          </Box>

          {/* Tabla */}
          <div style={{ width: '100%', display: loading ? 'none' : 'block' }}>
            <DataTable ref={tableRef} className="display" options={tableOptions} />
          </div>
        </Box>
        {loading && (
          <>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '50vh',
              }}
            >
              <CircularProgress />
            </Box>
          </>
        )}
      </Box>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={8000}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClose={() => setSnackbar((p) => ({ ...p, open: false }))}
      >
        <Alert
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: '100%' }}
          action={
            snackbar.confirm && (
              <Button
                color="inherit"
                size="small"
                onClick={() => {
                  snackbar.onConfirm?.();
                  setSnackbar((p) => ({ ...p, open: false }));
                }}
              >
                Confirmar
              </Button>
            )
          }
        >
          {snackbar.title && <AlertTitle>{snackbar.title}</AlertTitle>}
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default UploadPointsSection;
